import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { AzureBlobStorageLocation } from 'app/model/dataset/location/azure-blob.location';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobStorageLocation)
})
export class AzureBlobStorageLocationAdapter extends FileLocationAdapter<AzureBlobStorageLocation, Model.DatasetLocation> {
    public _toResource(store: AzureBlobStorageLocation): Model.AzureBlobLocation {
        const resource: Model.AzureBlobLocation = {
            type: 'AzureBlobStorageLocation',
            fileName: ValueAdapter.toResource(store, AzureBlobStorageLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, AzureBlobStorageLocation.FOLDER_PATH) || undefined,
            container: ValueAdapter.toResource(store, AzureBlobStorageLocation.CONTAINER) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.AzureBlobLocation, owner: Named): AzureBlobStorageLocation {
        const model = Owned.create<AzureBlobStorageLocation>(AzureBlobStorageLocation.MODEL, owner);
        ValueAdapter.toModel(model, AzureBlobStorageLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, AzureBlobStorageLocation.FOLDER_PATH, resource.folderPath);
        ValueAdapter.toModel(model, AzureBlobStorageLocation.CONTAINER, resource.container);
        return model;
    }
}
